import { relations } from "drizzle-orm";
import { index, integer, jsonb, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { users } from "./users";
import { conversations } from "./chat";
export var ScheduledTaskKind;
(function (ScheduledTaskKind) {
    ScheduledTaskKind["AUTONOMOUS_TASK"] = "autonomous_task";
    ScheduledTaskKind["REMINDER"] = "reminder";
})(ScheduledTaskKind || (ScheduledTaskKind = {}));
export var ScheduledTaskStatus;
(function (ScheduledTaskStatus) {
    ScheduledTaskStatus["ACTIVE"] = "active";
    ScheduledTaskStatus["PAUSED"] = "paused";
    ScheduledTaskStatus["CANCELLED"] = "cancelled";
    ScheduledTaskStatus["COMPLETED"] = "completed";
    ScheduledTaskStatus["RUNNING"] = "running";
})(ScheduledTaskStatus || (ScheduledTaskStatus = {}));
export var ScheduledScheduleType;
(function (ScheduledScheduleType) {
    ScheduledScheduleType["ONCE"] = "once";
    ScheduledScheduleType["RECURRING"] = "recurring";
})(ScheduledScheduleType || (ScheduledScheduleType = {}));
export const scheduledTasks = pgTable("scheduled_tasks", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    createdByUserId: uuid("created_by_user_id")
        .notNull()
        .references(() => users.id, { onDelete: "cascade" }),
    conversationId: uuid("conversation_id").references(() => conversations.id, {
        onDelete: "set null",
    }),
    title: text("title").notNull(),
    kind: text("kind").notNull().$type(),
    instruction: text("instruction").notNull(),
    timezoneSnapshot: text("timezone_snapshot").notNull(),
    scheduleType: text("schedule_type").notNull().$type(),
    nextRunAt: timestamp("next_run_at", { withTimezone: true }).notNull(),
    recurrence: jsonb("recurrence").$type(),
    status: text("status")
        .notNull()
        .$type()
        .default(ScheduledTaskStatus.ACTIVE),
    lastRunAt: timestamp("last_run_at", { withTimezone: true }),
    lastError: text("last_error"),
    runCount: integer("run_count").notNull().default(0),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    dueIdx: index("idx_scheduled_tasks_due").on(table.status, table.nextRunAt),
    companyCreatedIdx: index("idx_scheduled_tasks_company_created").on(table.companyId, table.createdAt),
    companyStatusIdx: index("idx_scheduled_tasks_company_status").on(table.companyId, table.status),
}));
export const scheduledTasksRelations = relations(scheduledTasks, ({ one }) => ({
    organisation: one(organisations, {
        fields: [scheduledTasks.companyId],
        references: [organisations.id],
    }),
    createdBy: one(users, {
        fields: [scheduledTasks.createdByUserId],
        references: [users.id],
    }),
    conversation: one(conversations, {
        fields: [scheduledTasks.conversationId],
        references: [conversations.id],
    }),
}));
